import * as Types from 'pages/Features/tabs/Profile/TimezoneAndWorkHours/typings';

export const AM_PM_FORMAT = 'hh:mm A';

export const WEEK_DAY_NAMES = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
] as Types.WeekDay[];

export const WEEK_DAY_ABBREVIATIONS = {
  Sunday: 'S',
  Monday: 'M',
  Tuesday: 'T',
  Wednesday: 'W',
  Thursday: 'T',
  Friday: 'F',
  Saturday: 'S',
};

export const DEFAULT_WORK_HOURS = {
  startTime: {
    hour: 9,
    minute: 0,
  }, // 9AM
  endTime: {
    hour: 17,
    minute: 0,
  }, // 5PM
} as Types.WorkHours;

const DEFAULT_WORK_HOURS_BY_DAY = {
  Sunday: null,
  Monday: {
    day: 1,
    ...DEFAULT_WORK_HOURS,
  },
  Tuesday: {
    day: 2,
    ...DEFAULT_WORK_HOURS,
  },
  Wednesday: {
    day: 3,
    ...DEFAULT_WORK_HOURS,
  },
  Thursday: {
    day: 4,
    ...DEFAULT_WORK_HOURS,
  },
  Friday: {
    day: 5,
    ...DEFAULT_WORK_HOURS,
  },
  Saturday: null,
} as Types.WorkHoursByDay;

export default DEFAULT_WORK_HOURS_BY_DAY;
